export default {
  TOAST_TIMEOUT: 8000,
  TOAST_SUCCESS_TIMEOUT: 3500,
  TOAST_SUCCESS_LONG_TIMEOUT: 8000,
  TOAST_WARNING_TIMEOUT: 5000,
  TOAST_WARNING_LONG_TIMEOUT: 8000,
  TOAST_ERROR_TIMEOUT: 10000,
}
